import type { ComponentProps } from "react";
import { cn } from "@/lib/utils";

/** Stacks actions on small screens and lets long labels wrap without clipping. */
export function ActionGroup({
  className,
  align = "end",
  reverse = false,
  ...props
}: ComponentProps<"div"> & {
  align?: "start" | "center" | "end";
  reverse?: boolean;
}) {
  return (
    <div
      className={cn(
        "flex min-w-0 gap-3 sm:flex-row sm:flex-wrap [&_[data-slot=button]]:h-auto [&_[data-slot=button]]:min-h-11 [&_[data-slot=button]]:whitespace-normal",
        reverse ? "flex-col-reverse" : "flex-col",
        {
          start: "sm:justify-start",
          center: "sm:justify-center",
          end: "sm:justify-end",
        }[align],
        className
      )}
      {...props}
    />
  );
}
